const sireReviewVersion = [
    { label: 'V1Q7', value: '0' },
    { label: 'SIRE 2.0', value: '1' }
];

export default sireReviewVersion;
